import { PageResponse } from '..';

export class FileChecksum {
    id?: string;
    sectionName?: string;
    rawAddress?: number;
    virtualAddress?: number;
    size?: number;
    flags?: string;
    flagWarning?: string;
    comment?: string;
    deletable?: boolean;
    exclusion?: boolean;

    currentlyCreated: boolean = false;
}

export class FileChecksumResponse extends PageResponse {
    content: FileChecksum[];
}

export class UpdateFileChecksum {
    constructor(public fileChecksums: FileChecksum[]) {

    }

}

export class AddFileChecksumExclusionRequest {
    constructor(public virtualAddress: number, public size: number,
                public deletable: boolean, public exclusion: boolean,
                public comment: string) {}
}

export class UpdateFileChecksumRequest {
    constructor(public fileChecksumSettings: FileChecksum[]) {
    }
}

export class ChangeFileChecksumRequest {
}
